import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getLearningStageGraph = async () => {
  return serviceHelper(http.get('/admin/report/learning-stage-graph'), false);
};

export const getTopSchoolsGraph = async () => {
  return serviceHelper(http.get('/admin/report/top-schools-graph'), false);
};

export const getSubscriptionDistribution = async () => {
  return serviceHelper(
    http.get('/admin/report/subscription-distribution-graph'),
    false
  );
};

export const getUserEngagementGraph = async (filter: number) => {
  return serviceHelper(
    http.get(`/admin/report/user-engagement-graph?filter=${filter}`),
    false
  );
};

export const getTopSchoolsLicenseAnalytics = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/report/license-analytics/top-schools${queryString ? `?${queryString}` : ''}`
    ),
    false
  );
};

export const getOverviewStats = async () => {
  return serviceHelper(http.get('/admin/report/overview-stats'), false);
};

export const getSchoolsDropdown = async () => {
  return serviceHelper(http.get('/admin/report/schools-dropdown'), false);
};

export const getParentsDropdown = async () => {
  return serviceHelper(http.get('/admin/report/parents-dropdown'), false);
};

export const getGamesDropdown = async () => {
  return serviceHelper(http.get('/admin/report/games-dropdown'), false);
};

export const getLearningProgress = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/report/learning-progress${queryString ? `?${queryString}` : ''}`
    ),
    false
  );
};

export const exportLearningProgress = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/report/export/learning-progress${queryString ? `?${queryString}` : ''}`,
      { responseType: 'blob' }
    ),
    false
  );
};

export const getSchoolLicenseReport = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/report/license-report/school${queryString ? `?${queryString}` : ''}`
    ),
    false
  );
};

export const getSchoolLicenseDetails = async (id: string) => {
  return serviceHelper(http.get(`/admin/report/school-details/${id}`), false);
};

export const exportSchoolLicenseReport = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/report/export/license-report/school${queryString ? `?${queryString}` : ''}`,
      { responseType: 'blob' }
    ),
    false
  );
};
